import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/dialogs/basic-donate-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/hero/fullscreen-hero.tsx");
